/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsupcomingevents2Inputs */

const en_statsupcomingevents2 = /** @type {(inputs: Statsupcomingevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming events`)
};

const de_statsupcomingevents2 = /** @type {(inputs: Statsupcomingevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende Events`)
};

/**
* | output |
* | --- |
* | "Upcoming events" |
*
* @param {Statsupcomingevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsupcomingevents2 = /** @type {((inputs?: Statsupcomingevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsupcomingevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsupcomingevents2(inputs)
	return de_statsupcomingevents2(inputs)
});
export { statsupcomingevents2 as "statsUpcomingEvents" }